import { useSafeTranslation } from 'shared/i18n';

type SubtitleProps = {
  email: string;
};

export const Subtitle = ({ email }: SubtitleProps) => {
  const { t } = useSafeTranslation();

  return (
    <div className="p-p mt8">
      {t('components.account.subtitle.loggedInWith', 'You are logged in with')}{' '}
      <span className="fw-bold">{email}</span>
    </div>
  );
};
